// extracted by mini-css-extract-plugin
export default {"studio-page":"Studio_studio-page__kc7DN","intro-section":"Studio_intro-section__PXEvK","interviews-section":"Studio_interviews-section__zKkKI"};